/* eslint-disable no-underscore-dangle */
import icon from 'src/libs/Leaflet.draw/images/marker-icon.png';
import shadow from 'src/libs/Leaflet.draw/images/marker-shadow.png';
import icon2x from 'src/libs/Leaflet.draw/images/marker-icon-2x.png';

// @ts-ignore
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: icon2x,
  iconUrl: icon,
  shadowUrl: shadow,
});
